export default "__VITE_ASSET__DkH$DmQs__"